import { apiClient } from './apiClient';
import { authService } from './authService';

const getCompanyParam = () => {
  const companyId = authService.getCompanyId();
  return companyId ? `companyId=${companyId}` : '';
};

export const supplierService = {
  // Get all suppliers
  async getSuppliers() {
    return apiClient.get(`/api/cmms/suppliers?${getCompanyParam()}`);
  },

  // Get suppliers by status
  async getSuppliersByStatus(status) {
    return apiClient.get(`/api/cmms/suppliers/status/${status}?${getCompanyParam()}`);
  },

  // Get suppliers by type
  async getSuppliersByType(type) {
    return apiClient.get(`/api/cmms/suppliers/type/${type}?${getCompanyParam()}`);
  },

  // Get single supplier by ID
  async getSupplierById(id) {
    return apiClient.get(`/api/cmms/suppliers/${id}?${getCompanyParam()}`);
  },

  // Get supplier by code
  async getSupplierByCode(code) {
    return apiClient.get(`/api/cmms/suppliers/code/${code}?${getCompanyParam()}`);
  },

  // Create new supplier
  async createSupplier(data) {
    return apiClient.post(`/api/cmms/suppliers?${getCompanyParam()}`, data);
  },

  // Update supplier
  async updateSupplier(id, data) {
    return apiClient.put(`/api/cmms/suppliers/${id}?${getCompanyParam()}`, data);
  },

  // Delete supplier
  async deleteSupplier(id) {
    return apiClient.delete(`/api/cmms/suppliers/${id}?${getCompanyParam()}`);
  },
};
